// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"banner-module--wrapper--1qopG","section":"banner-module--section--1BHzz","title":"banner-module--title--26ScU","paragraph":"banner-module--paragraph--kYWE-"};